import { render } from "./AjustePonto.vue?vue&type=template&id=0dec651d&scoped=true"
import script from "./AjustePonto.vue?vue&type=script&lang=js"
export * from "./AjustePonto.vue?vue&type=script&lang=js"

import "./AjustePonto.vue?vue&type=style&index=0&id=0dec651d&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0dec651d"]])

export default __exports__